import { useState } from "react";

export default function useOpen(initial = {}) {
  const [value, setValue] = useState(initial);

  function change(key, newValue) {
    setValue((value) => ({ ...value, [key]: newValue }));
  }
  function get(key) {
    return value[key] ?? false;
  }

  return { change, get };
}
